export const getAvatarInitialsColour = (initials) => {
  let firstNameInitial = initials[0].toLowerCase()

  if (firstNameInitial < 'd') {
    return "green"
  }
  if (firstNameInitial < 'g') {
    return "pink"
  }
  if (firstNameInitial < 'j') {
    return "cyan"
  }
  if (firstNameInitial < 'm') {
    return "purple"
  }
  if (firstNameInitial < 'p') {
    return "orange"
  }
  if (firstNameInitial < 't') {
    return "cyan"
  }
  if (firstNameInitial < 'w') {
    return "pastelblue"
  }
  if (firstNameInitial < 'p') {
    return "pastelsea"
  }
  if (firstNameInitial < 's') {
    return "yellow"
  }

  return null
}



// WEBPACK FOOTER //
// ./src/utils/avatar/index.js